module.exports = __webpack_public_path__ + "img/luna child_sc1.a7819d91.png";